export const MAIN_SITE_LINK = 'https://www.zoopla.co.uk';
export const GOOGLE_MAPS_URL = 'https://maps.googleapis.com';

// could we get away without setting these as strings?
export enum LayoutVersion {
    Mobile = 'mobile',
    Desktop = 'desktop'
}

export const MonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const ZOOPLA_PRODUCTION_URL = 'https://www.zoopla.co.uk';

export const LISTING_IMAGE_URL_CROPPED_PREFIX = 'https://lid.zoocdn.com/';

export const TRACKING_EVENT = 'GAEvent';

export const responsiveSizesPage =
    '(min-width: 1280px) 800px, (min-width: 960px) 66vw, 100vw';
